/* eslint-disable */
import { ChainId } from '@noahswap/sdk'
import { atom, useAtomValue } from 'jotai'
import { useRouter } from 'next/router'
import { useDeferredValue } from 'react'
import { isChainSupported } from 'utils/wagmi'
import { useNetwork } from 'wagmi'
import { useSessionChainId } from './useSessionChainId'
import { DEFAULT_CHAINID } from 'config'
export const sessionChainIdAtom = atom<number>(0)
const queryChainIdAtom = atom(-1) // -1 unload, 0 no chainId on query

queryChainIdAtom.onMount = (set) => {
  const params = new URL(window.location.href).searchParams
  const c = params.get('chainId')
  if (isChainSupported(+c)) {
    set(+c)
  } else {
    set(0)
  }
}

export function useLocalNetworkChain() {
  const [sessionChainId] = useSessionChainId()
  // useRouter is kind of slow, we only get this query chainId once
  const queryChainId = useAtomValue(queryChainIdAtom)

  const { query } = useRouter()

  let chainId = +(sessionChainId || query.chainId || queryChainId)
  // chainId = process.env.NODE_ENV === 'development' ? 15557 : 17777
  chainId = DEFAULT_CHAINID
  if (typeof window !== 'undefined' && window.localStorage) {
    if (localStorage.getItem('chainId')) {
      chainId = Number(localStorage.getItem('chainId'))
    }
  }
  // console.log('+++++++++++++++', chainId)
  if (isChainSupported(chainId)) {
    return chainId
  }

  return undefined
}

export const useActiveChainId = () => {
  const localChainId = useLocalNetworkChain()
  const queryChainId = useAtomValue(queryChainIdAtom)

  const { chain } = useNetwork()
  let chainId = localChainId ?? chain?.id ?? (queryChainId >= 0 ? ChainId.EVM_NET : undefined)
  // chainId = process.env.NODE_ENV === 'development' ? 15557 : 17777
  chainId = DEFAULT_CHAINID
  if (typeof window !== 'undefined' && window.localStorage) {
    if (localStorage.getItem('chainId')) {
      chainId = Number(localStorage.getItem('chainId'))
    }
  }
  const isNotMatched = useDeferredValue(chain && localChainId && chain.id !== localChainId)

  return {
    chainId,
    isWrongNetwork: (chain?.unsupported ?? false) || isNotMatched,
    isNotMatched,
  }
}
